import React from "react"

const Title = ({ title, date, hideDate, hideRelease }) => (
	<header className='p20 max-950 ma pb0'>
		{!hideRelease && <p className='sub-heading grey-100 op-75 mb20'>For Immediate Release</p>}
		<h1 className='h2 grey'>{title}</h1>
		{!hideDate && <p className='grey-100 mt40 op-75 med tracking-wide'>{date}</p>}
	</header>
)

export default Title
